<template>
    <div>
        <Dialog v-model:visible="visible" :style="{ width: '600px' }" :header="props.header" :modal="true" :dismissableMask="true" @hide="$emit('hide-dialog', true)">
            <div class="p-fluid formgrid grid">
                <div class="field col-12 md:col-6">
                    <label for="name">Assessment Name</label>
                    <InputText maxlength = "255" id="name" :class="{ 'p-invalid': submitted && !assessmentStore.assessment.name }" v-model="assessmentStore.assessment.name" placeholder="Enter assessment name" />
                    <small id="nameError" class="p-invalid" v-if="submitted && !assessmentStore.assessment.name">Assessment Name is required.</small>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="code">Code</label>
                    <InputText maxlength = "255" id="code" :class="{ 'p-invalid': submitted && !assessmentStore.assessment.code }" v-model="assessmentStore.assessment.code" placeholder="Enter unique assessment code" />
                    <small class="p-invalid" v-if="submitted && !assessmentStore.assessment.code">Assessment Code is required.</small>
                </div>
                <div class="field col-12 md:col-6">
                    <label for="category">Category</label>
                    <Dropdown id="category" v-model="assessmentStore.assessment.category_id" :options="assessmentStore.categories" optionLabel="name" optionValue="id" placeholder="Select Category Type" showClear />
                </div>
                <div class="field col-12 md:col-6">
                    <div class="flex flex-column gap-2">
                        <label for="category">Draft</label>
                        <ToggleButton v-model="assessmentStore.assessment.draft" onLabel="True" offLabel="False" class="w-9rem" />
                    </div>
                </div>
                <div class="field col-12">
                    <label for="description">Description</label>
                    <Textarea id="description" rows="4" v-model="assessmentStore.assessment.description" />
                </div>
            </div>
            <template #footer>
                <Button label="Cancel" icon="pi pi-times" class="mx-1 p-button-danger" @click="emit('hide-dialog', true)" />
                <Button label="Submit" icon="pi pi-check" class="mx-1 p-button-primary" @click="submit()" />
            </template>
        </Dialog>
    </div>
</template>

<script setup>
import { ref, defineEmits, defineProps } from 'vue';
import { useAssessmentStore } from '../store';

const emit = defineEmits(['hide-dialog']);
const props = defineProps({
    mode: {
        type: String,
        default: 'add',
    },
    header: {
        type: String,
        default: 'Create a new assessment',
    },
});

const assessmentStore = useAssessmentStore();

const submitted = ref(false);
const visible = ref(true);

const submit = async () => {
    submitted.value = true;
    if (isValid()) {
        let assessmentObj = null;
        if (props.mode == 'edit') {
            assessmentObj = await assessmentStore.updateAssessment(assessmentStore.editAssessmentId, assessmentStore.assessment);
        } else {
            // create an assessment
            assessmentObj = await assessmentStore.addAssessment(assessmentStore.assessment);
        }
        // if assessment creation or update is success then close form
        if (assessmentObj?.id) {
            closeForm();
        }
    }
};

function isValid() {
    if (!assessmentStore.assessment.name || !assessmentStore.assessment.code) {
        return false;
    }
    return true;
}

function closeForm() {
    submitted.value = false;
    emit('hide-dialog', true);
}
</script>
